export const jsonUrl = "/json/";
export const jsonStatusBatchUrl = "/json/status/batch";
export const jsonStatusUrl = "/json/status/";
